/**
 * 地区信息
 */
import { BaseRegionDTO } from '@api/gateway/PlatformBasicData'

export class Region {
  id: string
  name: string
  path: string
  parentId: string

  static fromBaseRegionDTO(dto: BaseRegionDTO) {
    const region = new Region()
    region.id = dto.id
    region.name = dto.name
    region.path = dto.regionPath
    region.parentId = dto.parentId
    return region
  }
}
